import type { JiraPlatformComment } from '../../types';

export const isJiraPlatformComment = (entity: any): entity is JiraPlatformComment =>
	entity.__typename === 'JiraPlatformComment';

export const getJiraPlatformCommentLink = (comment: JiraPlatformComment): string | null =>
	comment?.webUrl ?? null;
